import { Injectable } from '@angular/core';

import { LogEntry } from '../models/log-entry';

@Injectable({ providedIn: 'root' })
export class LogDB {
	getEntries() {
		const entriesStr = localStorage.getItem('copo-log-entries');
		return entriesStr ? <LogEntry[]> JSON.parse(entriesStr) : [];
	}

	saveEntries(entries: LogEntry[]) {
		localStorage.setItem('copo-log-entries', JSON.stringify(entries));
	}

	addLogEntry(logEntry: LogEntry) {
		const entries = this.getEntries();
		entries.push(logEntry);
		this.saveEntries(entries);
	}

	addLogEntries(logEntries: LogEntry[]) {
		const entries = this.getEntries();
		entries.push(...logEntries);
		this.saveEntries(entries);
	}

	removeLogEntries() {
		const entries = this.getEntries();
		this.saveEntries([]);
		return entries;
	}
}
